var $giftwrapAdded = sessionStorage.getItem('giftwrapAdded');
var $giftwrapPaid = sessionStorage.getItem('giftwrapPaid');
var $giftwrapFree = sessionStorage.getItem('giftwrapFree');


function giftwrapSubmit () {
  sessionStorage.setItem('giftwrapAdded', 'true');
  if (document.getElementById('giftwrap-paid')) {
    sessionStorage.setItem('giftwrapPaid', 'true');
  } else {
    sessionStorage.setItem('giftwrapFree', 'true');
  }
}

// clicks the remove button of the hidden Gift Wrapping line item in the cart
function giftwrapRemove () {
  sessionStorage.setItem('giftwrapAdded', 'false');
  document.querySelector('.giftwrap-remove').click();
}